'use strict'

export default class Modals {
  constructor () {
    this.classes = {
      button: '.show-modal',
      close: '.close',
      overlay: '.overlay',
      canvas: '.sl__canvas'
    }
    this.delay = 350
    this.activeModal = null
    this.overlay = document.querySelector(this.classes.overlay)

    this.parseButtons()
    if (this.overlay) {
      this.overlay.addEventListener('click', () => { this.hideModal() })
    }
  }

  parseButtons () {
    const buttons = document.querySelectorAll(this.classes.button)

    Array.prototype.forEach.call(buttons, (button) => {
      var modal = document.getElementById(button.id + '-modal')
      this.clickEvents(button, modal)
    })
  }

  clickEvents (button, modal) {
    if (modal === null) { return false }

    const close = modal.querySelector(this.classes.close)

    button.addEventListener('click', () => { this.showModal(button, modal) })

    if (close !== null) { close.addEventListener('click', () => { this.hideModal() }) }
  }

  showModal (button, modal) {
    const canvas = button.closest(this.classes.canvas)

    this.overlay.classList.add('active')

    window.setTimeout(() => {
      button.setAttribute('aria-expanded', 'true')
      modal.setAttribute('aria-expanded', 'true')
      modal.classList.add('active')
      document.body.classList.add('fixed')

      if (button.classList.contains('--middle')) {
        canvas.style.transform = 'translateX(-25%)'
      } else if (button.classList.contains('--right')) {
        canvas.style.transform = 'translateX(-58.33%)'
      }
    }, this.delay)

    this.activeModal = modal
  }

  hideModal () {
    // console.log('hide')
    const canvas = document.querySelector(this.classes.canvas)

    $('.youtube iframe').each(function () {
      $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
    })

    this.activeModal.setAttribute('aria-expanded', 'false')
    this.activeModal.classList.remove('active')
    document.body.classList.remove('fixed')
    canvas.style.transform = ''

    window.setTimeout(() => {
      this.overlay.classList.remove('active')
    }, this.delay)
  }
}
